var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6271 0.893187C53.7512 0.893186 69.2543 16.3963 69.2543 35.5203C69.2543 54.6444 53.7512 70.1475 34.6271 70.1475C15.5031 70.1475 -6.77662e-07 54.6444 -1.5136e-06 35.5203C-2.34954e-06 16.3963 15.5031 0.893188 34.6271 0.893187Z",
    fill: "#4B5158"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3527 52.5331L18.543 22.708C18.3023 22.2321 18.6642 21.6689 19.1974 21.6689H24.3291C24.6044 21.6689 24.8623 21.823 24.9835 22.061L35.7991 43.6984C36.7634 45.6396 39.5526 45.6396 40.5169 43.6984L51.2979 22.0781C51.4191 21.8401 51.677 21.6861 51.9523 21.6861H52.5895C52.9686 21.6861 53.2093 22.0781 53.0379 22.4016L38.0723 52.5331C37.108 54.4726 34.3171 54.4726 33.3527 52.5331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.3529 52.5335L24.9837 22.0785C24.8625 21.8235 24.5872 21.6865 24.3639 21.6865H19.215C18.6471 21.6865 18.3199 22.248 18.5432 22.7256L33.3529 52.5335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.8006 43.7138L18.5445 22.708C18.3385 22.215 18.6484 21.7203 19.1297 21.6689H24.3479C24.6405 21.6861 24.8638 21.8727 24.9677 22.061L35.8006 43.7138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6271,
    height: 32.3187,
    fill: "white",
    transform: "translate(18.4673 21.6689)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.5ebba62d4ca22b66315b3fd9058ce14e.svg";
export { ForwardRef as ReactComponent };